import { render, staticRenderFns } from "./Home_process.vue?vue&type=template&id=55d3aef4&scoped=true"
import script from "./Home_process.vue?vue&type=script&lang=js"
export * from "./Home_process.vue?vue&type=script&lang=js"
import style0 from "./Home_process.vue?vue&type=style&index=0&id=55d3aef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3aef4",
  null
  
)

export default component.exports